// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__38xcG","containerItemsCenter":"Skeleton_containerItemsCenter__3urVt"};